import { ReactElement } from 'react';

import Text from '../Text';
import { TextBaseProps, TextElements, TextLabelProps } from '../Text/types';
import { Wrapper } from './styles';
import { TextAreaProps } from './types';

export const DefaultLabelComponent = (props: Omit<TextBaseProps & TextLabelProps, 'color'>): ReactElement => (
	<Text el={TextElements.Label} {...props} />
);

const TextArea = ({ className, resizable = true, ...props }: TextAreaProps): ReactElement => {
	// Our "label inside the border" design doesn't work with textareas
	// because the text overlaps the label while the user types,
	// because browsers don't respect padding in textareas as they grow
	const LabelComponent = props.LabelComponent ?? (props.label ? DefaultLabelComponent : undefined);
	return (
		<Wrapper
			LabelComponent={LabelComponent}
			{...props}
			UNSAFE_showFocus={props.$UNSAFE_showFocus}
			UNSAFE_hasBlurred={props.$UNSAFE_hasBlurred}
			customInputIsTextArea
			CustomInputProps={{ $resizable: resizable, className }}
		/>
	);
};

export default TextArea;
